import Layout from "@/layout";

export default {
  path: "/map",
  component: Layout,
  redirect: "/map/index",
  children: [
    {
      path: "index",
      component: () => import(/* webpackChunkName: "map" */ "@/views/map"),
      name: "map",
      meta: { title: "Map", icon: "map-v2", keepName: 'tripPlanning', keepAlive: true }
    }
  ]
}